module.exports = __webpack_public_path__ + "static/media/as.c7a6bb4e.svg";